// Centralised status presentation — used by Admin panel + Account Orders tab
// + Order Confirmation page so colours stay in sync.

export const STATUS_LABEL = {
  "Pending Payment - Zelle": "Pending Payment - Zelle",
  "Payment Confirmed":       "Payment Confirmed",
  "Shipped / Fulfilled":     "Shipped / Fulfilled",
  "Cancelled":               "Cancelled",
  "Expired - Payment Not Received": "Expired — Payment Not Received",
};

// Tailwind class strings — picked so they coexist with the cream/plum palette
// without us needing to extend the theme.
export const STATUS_PILL_CLASS = {
  // Yellow → pending
  "Pending Payment - Zelle": "bg-amber-100 text-amber-800 border border-amber-300",
  // Blue → confirmed
  "Payment Confirmed":       "bg-blue-100 text-blue-800 border border-blue-300",
  // Green → shipped
  "Shipped / Fulfilled":     "bg-emerald-100 text-emerald-800 border border-emerald-300",
  // Neutral → cancelled (kept for future)
  "Cancelled":               "bg-charcoal-100 text-charcoal-500 border border-charcoal-200",
  // Rose → refunded (full/partial)
  "Refunded":                "bg-rose-100 text-rose-800 border border-rose-300",
  "Partially Refunded":      "bg-rose-100 text-rose-800 border border-rose-300",
  // Orange → auto-expired unacknowledged Zelle drafts (24h). Distinct from
  // grey "Cancelled" so customers can tell an admin didn't manually cancel.
  "Expired - Payment Not Received":
    "bg-orange-100 text-orange-800 border border-orange-300",
};

// Human-friendly label used by all UIs. Falls back to the raw status if we
// don't have a mapping (defensive against new server-side statuses).
export const statusLabel = (status) => STATUS_LABEL[status] || status;

export const statusPillClass = (status) =>
  STATUS_PILL_CLASS[status] || STATUS_PILL_CLASS["Cancelled"];

// Shipping carrier select options used by the admin "Mark Fulfilled" form.
export const CARRIER_OPTIONS = ["USPS", "UPS", "FedEx", "DHL", "Other"];
